export enum LoginSource {
    QRCODE = 'qr_code',
    GOOGLE = 'google',
    FACEBOOK = 'facebook',
    EMAIL = 'email',
    PHONE = 'phone'
}